import type { FaireProductEntity } from "../../entity_types/product";

export const p_uhyn5r2ujv: FaireProductEntity = {
  token: "p_uhyn5r2ujv",
  type: "product",
  name: "Off Leash Little Notes®",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/bc54ba0b01480bdc9e252f9e9f49ba7a23713278db8934f9ca1a77db2b1bda1f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ca2cdf8bea6b3493b5629228866219242fafd1084555fa2e2fc0d4b5e69ddcc8.jpeg",
    "https://cdn.faire.com/fastly/22779bbee0889e94cff657e06e06f579a9901f467982601013144b8634ec82e9.jpeg",
    "https://cdn.faire.com/fastly/34841fa5f25d09cdf13ec624c75651efa31ebee43d703dc5e34eef6811321ac8.png",
  ],
  priceDollars: 7,
  description:
    "Little Notes® are tiny in size and big on heart. Small enough to slip in a pocket, a lunch box, or a stack of books, each one carries something much larger than its size: a laugh, a love note, a small connection. Whether it’s a joke tucked into a backpack, a to-do list turned sweet, or a simple “thank you,” Little Notes® bring joy to life’s little, big and in-between moments.\n\nEvery Little Note features hand-painted watercolor illustrations, front and back, so even the simplest message feels special. With 55 per pack, you can mix, match and share freely. Over 69 million Little Notes® have already been shared worldwide, sparking connection one small gesture at a time.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:35:53.729Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
